export function arrayValues(arr: any[]): any[] {
  return (
    arr !== null &&
    arr
      .filter(
        item => typeof item === 'object' && item !== null && 'value' in item
      )
      .map(item => item.value)
  )
}
